export const WEBHOOK_EVENT_TYPES = [
  'APP_CREATE',
  'APP_DELETE',
  'APP_DEPLOY',
  'APP_UPDATE',
  'DATABASE_CREATE',
  'DATABASE_DELETE',
  'DATABASE_UPDATE',
  'STATIC_SITE_CREATE',
  'STATIC_SITE_DELETE',
  'STATIC_SITE_DEPLOY',
  'STATIC_SITE_UPDATE',
] as const
